var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    enableBackground: "new 0 0 305.002 305.002",
    fill: "green",
    viewBox: "0 0 305 305",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m152.5 1e-3c-84.09 0-152.5 68.411-152.5 152.5s68.412 152.5 152.5 152.5c84.089 0 152.5-68.411 152.5-152.5s-68.411-152.5-152.5-152.5zm0 280c-70.305 0-127.5-57.195-127.5-127.5 0-70.304 57.197-127.5 127.5-127.5 70.304 0 127.5 57.196 127.5 127.5 0 70.305-57.196 127.5-127.5 127.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m218.47 93.97-90.546 90.547-41.398-41.398c-4.882-4.881-12.796-4.881-17.678 0-4.881 4.882-4.881 12.796 0 17.678l50.237 50.237c2.441 2.44 5.64 3.661 8.839 3.661s6.398-1.221 8.839-3.661l99.385-99.385c4.881-4.882 4.881-12.796 0-17.678-4.882-4.882-12.797-4.882-17.678-1e-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approved-icon.0b602ab88c70584d6ea6e2cabb9db910.svg";
export { ForwardRef as ReactComponent };